module.exports = __webpack_public_path__ + "img/2025-0416-01-01.1396f84e.png";